<template>
    <page>
        <module enable-flex>
            <m-search @search="search">
                <m-search-item label="标题">
                    <c-input name="title"></c-input>
                </m-search-item>
                <m-search-item label="状态">
                    <c-select name="state" :options="[{name: '启用', value: 1}, {name: '禁用', value: 2}]"></c-select>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button
                        v-if="auth('b_rule_manage_edit')"
                        color="main"
                        prepend-icon="tf-add"
                        @click="editArticle()"
                >
                    新增规则
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="标题"
                        name="title"
                        width="320"
                        fixed="left"
                >
                </c-table-column>

                <c-table-column label="状态" width="100">
                    <template #default="{data}">
                        <c-switch
                                v-if="auth('b_rule_manage_state')"
                                v-model="data.state"
                                :state-value="[1, 2]"
                                :state-text="['启用', '禁用']"
                                @beforeChange="changeState(arguments[0], arguments[1], data)"
                        ></c-switch>
                        <c-state
                                v-else
                                dict="disableEnableDic"
                                :value="data.state"
                        ></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                    label="创建时间"
                    name="create_date"
                    width="160"
                >
                </c-table-column>

                <c-table-column
                        label="更新时间"
                        name="update_date"
                        width="160"
                >
                </c-table-column>

                <c-table-column type="button" label="操作" width="160">
                    <template #default="{data}">
                        <c-table-button icon="tf-edit" @click="editArticle(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_rule_manage_delete')" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>

        </module>
    </page>
</template>

<script>
export default {
    mounted() {
        this.search({});
    },

    methods: {
        editArticle(data) {
            this.globalDialog('systemArticleEdit', {
                props: {type: 'rule', id: data ? data.id : ''},
            }, () => this.$refs.list.update());
        },

        search(data) {
            this.$refs.list.load({
                url: '/article/list',
                data: Object.assign({}, data || {}, {article_type: 3}),
            });
        },

        /******教程启禁用*********/
        changeState(state, next, data) {
            this.request({
                url: '/article/state',
                data: {id: data.id, article_type: 3, state: state ? 2 : 1},
                success: () => this.$refs.list.update(),
            });
        },

        /******删除教程*********/
        remove(data) {
            this.$confirm({
                message: `确认删除【${data.title}】？`,
                cancelButton: true,
                resolve: () =>
                    this.request({
                        url: '/article/delete',
                        data: {id: data.id, article_type: 3},
                        success: () => this.$refs.list.update(),
                    }),
            });
        },

    },
};
</script>
